const fields = [
  {
    name: "companyName",
    label: "Company Name",
    disabled: true,
    select: true,
    value: "companyName",
  },
  {
    name: "ip",
    label: "IP Address",
    required: true,
    validationType: "string",
    disabled: false,
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    name: "description",
    label: "Description",
    required: true,
    disabled: false,
    validationType: "string",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    name: "isActive",
    label: "White IP Status",
    switch: true,
    validationType: "boolean",
    disabled: false,
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
];

export default fields;
